export default __webpack_public_path__ + "static/playground-83cbefa7f8f031cbd4c1149dbd8c911d.jpg";